import { InputLabel, Stack, Switch, TextField } from '@mui/material'
import { ChangeEventHandler } from 'react'

interface IProps {
    label: string
    type: string
    value?: string | boolean
    onChange?: ChangeEventHandler<HTMLInputElement>
    name?: string
    readOnly?: boolean
    error?: boolean
    helperText?: string
}

const Input: React.FC<IProps> = (props) => {
    const { label, type, value, onChange, name, readOnly = false, error, helperText } = props

    if (type === 'switch' && typeof value === 'boolean') {
        return (
            <Stack direction="row" alignItems="center">
                <Switch name={name} checked={value} onChange={onChange} />
                <InputLabel sx={{ color: value === true ? 'text.primary' : 'text.disabled' }}>{label}</InputLabel>
            </Stack>
        )
    }

    return (
        <Stack flexGrow={1}>
            <TextField
                variant="standard"
                type={type}
                disabled={readOnly}
                name={name}
                value={value}
                onChange={onChange}
                label={label}
                error={error}
                helperText={helperText}
            />
        </Stack>
    )
}

Input.displayName = 'Input'

export default Input
